import { BillingClient } from "@/lib/clients";
import { Plan, BillingInfo } from "@/lib/models";
import { ActionContext, ActionTree, GetterTree, MutationTree, Store } from "vuex";

const billingClient = new BillingClient();

// Stateの型定義
export interface BillingState {
  billingInfo: BillingInfo;
  plan: Plan;
}

type Actions = {
  fetchBillingInfo: (this: Store<{}>, injectee: ActionContext<BillingState, {}>) => any;
};

type Getters = {
  billingInfo(state: BillingState): BillingInfo;
  plan(state: BillingState): Plan;
  hasPaymentError(state: BillingState): boolean;
  invoiceUrl(state: BillingState): string | null;
};

const mutations: MutationTree<BillingState> = {
  setBillingInfo(state, payload: BillingInfo) {
    state.billingInfo = payload;
    state.plan = payload.plan;
  },
};

const actions: ActionTree<BillingState, {}> & Actions = {
  async fetchBillingInfo({ commit }) {
    const billingInfo = await billingClient.fetchBillingInfo();
    commit("setBillingInfo", billingInfo);
  },
};

const getters: GetterTree<BillingState, {}> & Getters = {
  billingInfo: (state) => state.billingInfo,
  plan: (state) => state.plan,
  hasPaymentError: (state) => !!state.billingInfo?.invoiceUrl,
  invoiceUrl: (state) => state.billingInfo?.invoiceUrl || null,
};

export default {
  namespaced: true,
  state: {
    billingInfo: {},
    plan: Plan.free,
  } as BillingState,
  getters,
  actions,
  mutations,
};
